import { parseFormattedNumber } from 'components/partials/formatted-input/formatted-input.helpers';

export const getValueLabel = (valueType: string | undefined): string => {
  const TYPES: Record<string, string> = {
    PERCENT: '%',
    DOLLAR: '$',
  };

  return `Value ${valueType && TYPES[valueType] ? `, ${TYPES[valueType]}` : ''}`;
};

export const validateValue = (
  value: string | number,
  valueType: string | undefined
): true | string => {
  if (value === '') {
    return 'This field is required';
  }
  const parsedValue = Number(parseFormattedNumber(value));

  if (Number.isNaN(parsedValue)) {
    return 'Invalid value format';
  }

  if (valueType === 'PERCENT' && (parsedValue <= 0 || parsedValue > 100)) {
    return `Value must be greater than 0 and less than or equal to 100`;
  }

  if (valueType?.startsWith('RANGE')) {
    const [min, max] = valueType.split('_').slice(-2).map(Number);

    if (parsedValue <= min || parsedValue > max) {
      return `Value must be greater than ${min} and less than or equal to ${max}`;
    }
  } else if (parsedValue <= 0) {
    return 'Value must be greater than 0';
  }

  return true;
};
